import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class Events {

    private hideSidemenu = new Subject();
    private showSidemenu = new Subject();
    private userLogin = new Subject();

    publishEvent(event: string, data: any) {
        if (event == 'hide-sidemenu')
            this.hideSidemenu.next(data);
        if (event == 'show-sidemenu')
            this.showSidemenu.next(data);
        if (event == 'user-login')
            this.userLogin.next(data);
    }

    observeEvent(event: string): Subject<any> {
        if (event == 'hide-sidemenu')
            return this.hideSidemenu;
        if (event == 'show-sidemenu')
            return this.showSidemenu;
        if (event == 'user-login')
            return this.userLogin;

        return null;
    }
}